import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import selectIsModalOpened from '../../../core/selectors/modal';
import { closeModal } from '../../../core/actions/modal';
import { FORGOT_PASSWORD_MODAL_NAME } from '../../constants/modal';
import { doForgotPassword } from '../../../core/actions/auth';
import { forgotPassword } from '../../api/sell';

const ForgotPasswordModal = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state) => selectIsModalOpened(state, FORGOT_PASSWORD_MODAL_NAME));

    const onClose = () => {
        dispatch(closeModal(FORGOT_PASSWORD_MODAL_NAME));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const email = e.target.elements['forgot-password-email'].value;
        dispatch(doForgotPassword(email, forgotPassword));
        onClose();
    };
    return (
        <Modal show={isOpen} onHide={onClose} className="forgotPasswordModal modal-fullscreen-sm-down">
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <h3 className="mb-0">
                    <FormattedMessage id="reset_password_title"/>
                </h3>
                <p className="mb-5"><FormattedMessage id="reset_password_subtitle"/></p>

                <Form onSubmit={handleSubmit}>
                    <FloatingLabel controlId="forgot-password-email" label={<FormattedMessage id="login_modal_email_placeholder"/>}
                        className="mb-3">
                        <Form.Control size="lg" label={<FormattedMessage id="login_modal_email_placeholder"/>}
                            type="email"
                            required="required"
                            placeholder={<FormattedMessage id="login_modal_email_placeholder"/>}/>
                    </FloatingLabel>
                    <div className="d-grid mt-4 mb-4">
                        <Button variant="primary" size="lg" type="submit">
                            <FormattedMessage id="reset_password_title"/>
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ForgotPasswordModal;
